/* RESPONSIBLE TEAM: team-actions */
import type Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import type Transition from '@ember/routing/transition';
import { hash } from 'rsvp';

export default class ProceduresIndexRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare store: Store;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare router: RouterService;
  @service declare permissionsService: $TSFixMe;

  get titleToken() {
    return this.intl.t('fin-ai-agent.train.procedures.title');
  }

  async beforeModel(transition: Transition) {
    // Redirect to tasks if feature flag is off
    if (!this.appService.app.canUseFinProcedures) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.tasks', {
        queryParams: transition.to?.queryParams || {},
      });
      return;
    }

    if (this.permissionsService.currentAdminCan('can_access_reporting')) {
      try {
        await this.reportingMetrics.loadMetricsAndProperties();
      } catch (e: unknown) {
        // Log error but allow page to render without metrics
        console.error('Failed to load reporting metrics:', e);
      }
    }
  }

  async model() {
    let messengerSettingsLanguages = await this.store.findRecord(
      'messenger-settings/languages',
      this.appService.app.id,
    );

    return hash({
      languages: messengerSettingsLanguages,
    });
  }
}
